export enum FilterStatusTypeEnum {
  DISTRIBUTION = 'DISTRIBUTION',
  FOLD = 'FOLD',
  MAIL = 'MAIL',
  ERL = 'ERL'
}

export enum StatusErlEnum {
  isErlCreated = 'isErlCreated',
  isErlPlanned = 'isErlPlanned',
  isErlReplayed = 'isErlReplayed',
  isErlLreSent = 'isErlLreSent',
  isErlInjected = 'isErlInjected',
  isErlSent = 'isErlSent',
  isErlPending = 'isErlPending',
  isErlErlFailed = 'isErlErlFailed',
  isErlAccepted = 'isErlAccepted',
  isErlRefused = 'isErlRefused',
  isErlExpired = 'isErlExpired',
  isErlClosed = 'isErlClosed',
  isErlLreCanceled = 'isErlLreCanceled',
  isErlSendPaper = 'isErlSendPaper'
}

export enum StatusMailEnum {
  isMailingWaitingSending = 'isMailingWaitingSending',
  isMailingLinkDownload = 'isMailingLinkDownload',
  isMailingLinkClick = 'isMailingLinkClick',
  isMailingPaper = 'isMailingPaper',
  isMailingReminderSend = 'isMailingReminderSend',
  isMailingMailFailed = 'isMailingMailFailed',
  isMailingSendSuccess = 'isMailingSendSuccess',
  isMailingInProgress = 'isMailingInProgress'
}
